import React from "react";
import styles from "../styles/svgHamburger.module.css";

const SVGHamburger = ({ isOpen, onClick, offsetLeft, offsetTop }) => {
  return (
    <div
      className={styles.svgHamburger}
      style={
        offsetLeft !== undefined || offsetTop !== undefined
          ? {
              left: offsetLeft !== undefined ? `${offsetLeft}px` : undefined,
              top: offsetTop !== undefined ? `${offsetTop}px` : undefined,
            }
          : undefined
      }
    >
      <label className={styles.menuLabel}>
        <input
          type="checkbox"
          checked={isOpen}
          onChange={onClick}
          className={styles.checkbox}
        />
        <svg
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.svg}
        >
          <path
            className={`${styles.line} ${styles.line1}`}
            d="M0 40h62c13 0 6 28-4 18L35 35"
          />
          <path className={`${styles.line} ${styles.line2}`} d="M0 50h70" />
          <path
            className={`${styles.line} ${styles.line3}`}
            d="M0 60h62c13 0 6-28-4-18L35 65"
          />
        </svg>
      </label>
    </div>
  );
};

export default SVGHamburger;
